import { useEffect, useMemo } from 'react'
import { Avatar, styled } from '@mui/material'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useProjectPrivateContext } from '../../context/projectContext'
import { colorPalette } from '../../style/colorPalette'
import { intl } from '../../../i18n'
import { projectPrivate } from '../../higher-order-components/projectPrivate'
import { APPLICATION_FUNCTION_EXTERNAL_ID, PageArea } from '../index'
import { AllState } from '../../../store'

const Content = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  flex: 1,
})

const ProjectIcon = styled(Avatar)({
  height: '64px',
  width: '64px',
  border: `solid ${colorPalette.monotone[2]} 1px`,
  marginBottom: '16px',
})

const WelcomeText = styled('div')({
  fontSize: '24px',
  fontWeight: '600',
  lineHeight: '36px',
  textAlign: 'center',
  color: colorPalette.monotone[4],
  whiteSpace: 'pre-line',
  padding: '10px',
})

export const ProjectTop = projectPrivate(() => {
  const { project } = useProjectPrivateContext()
  const history = useHistory()
  const functions = useSelector(
    (state: AllState) => state.appFunction.functions
  )

  const hasProjectPlan = useMemo(
    () =>
      functions.some(
        f =>
          f.externalId === APPLICATION_FUNCTION_EXTERNAL_ID.PROJECTPLAN_EDIT ||
          f.externalId === APPLICATION_FUNCTION_EXTERNAL_ID.PROJECTPLAN_NEW_EDIT
      ),
    [functions]
  )

  useEffect(() => {
    if (hasProjectPlan) {
      history.replace(`/projectPlan/${project.code}`)
    }
  }, [hasProjectPlan, project.code, history])

  if (hasProjectPlan) return <></>

  return (
    <PageArea>
      <Content>
        {project.iconUrl && (
          <ProjectIcon variant="rounded" src={project.iconUrl} />
        )}
        <WelcomeText>
          {intl.formatMessage(
            { id: 'projectTop.welcome' },
            { projectName: project.displayName }
          )}
        </WelcomeText>
      </Content>
    </PageArea>
  )
})
